import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function DevelopmentIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M23.4531 9.09717L19 10.3184V8H21V6H9V4.45703L5.5 1.11816L2 4.45703V6H0V8H2V23H4V8H7V23H9V8H17V10.8862L12.1465 12.2647L12.6934 14.1885L24 11.021L23.4531 9.09717ZM4 6V5.3125L5.5 3.88184L7 5.3125V6H4Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M13 23H15V17.3721L21 15.876V23H23V13.3154L13 15.8096V23Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M19 19H17V23H19V19Z",
    fill: "currentColor"
  }));
}